import defaultConfig from './default';
import masiConfig from './masihotels';
import sakForMasiHotelsConfig from './sakformasihotels';

const CONFIGS = {
  default: defaultConfig,
  masihotels: masiConfig,
  sakformasihotels: sakForMasiHotelsConfig
};

function getBrandId() {
  // Get brand from (in this order): URL, local storage, Environment, 'default'
  const paramsFromURL = new URLSearchParams(window.location.search);
  const brandFromURL = paramsFromURL.get('brand');

  if (brandFromURL) {
    localStorage.setItem('selectedBrand', brandFromURL); // persist it
  }

  const brandFromEnv = process.env.REACT_APP_BRAND;

  return brandFromURL || localStorage.getItem('selectedBrand') || brandFromEnv || 'default';
}

const brandId = getBrandId();

const config = CONFIGS[brandId] || defaultConfig;
export default config;
